import * as React from 'react';
import classNames from 'classnames';
import BaseHeading from '../../common/BaseHeading/BaseHeading.esm.js';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { Grid } from '../../common/Grid/Grid.esm.js';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './IconGrid.module.esm.js';

var IconGrid = function (_a) {
    var _b;
    var id = _a.id, _c = _a.fields, analyticsEvents = _c.analyticsEvents, body = _c.body, columns = _c.columns, heading = _c.heading, headingAlignment = _c.headingAlignment, internalName = _c.internalName, items = _c.items, theme = _c.theme, footer = _c.footer, dataCy = _a["data-cy"];
    var className = classNames(styles.root, (_b = {},
        _b[styles[theme]] = theme,
        _b));
    return (React.createElement(BaseSectionWithAnalyticsContext, { analyticsEvents: analyticsEvents, className: className, "data-cy": dataCy, id: id, sectionName: internalName },
        React.createElement("div", { className: "nv-container" },
            heading && React.createElement(BaseHeading, { body: body, heading: heading, headingAlignment: headingAlignment }),
            React.createElement(Grid, { className: styles.grid, role: "list", withoutContainer: true }, items.map(function (item, key) { return (React.createElement(BaseNucleobaseComponent, { classes: { root: classNames(styles["gridItem".concat(columns)], "alignment-".concat(headingAlignment)) }, key: key, source: item })); })),
            footer && (React.createElement("div", { className: styles.footer },
                React.createElement(BaseNucleobaseComponent, { source: footer }))))));
};

export { IconGrid as default };
//# sourceMappingURL=IconGrid.esm.js.map
